/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { connect } from 'react-redux';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import I18n from '../../../components/Translate/I18n';
import ReportHelper from '../../../helpers/ReportHelper';
import GridContainer from '../../../components/Grid/GridContainer';
import Typography from '@material-ui/core/Typography';
import GridItem from '../../../components/Grid/GridItem';
import DialogContent from '@material-ui/core/DialogContent';
import PlatformResellerInterface from "../../../interfaces/platform/PlatformResellerInterface";

interface ReportViewProps {
    dispatch: any;
    classes: any;
    item: any;
    translations?: Array<{name: string, value: Array<any>}>;
}

class ReportView extends PureComponent<ReportViewProps> {
    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { classes, item,translations } = this.props;
        const size = 6;
        const variant = 'subtitle2';

        if (item !== null) {
            let params = JSON.parse(item.params);

            return (
                <DialogContent>
                    {item.typeId === ReportHelper.reportType.CASE_STATES && (
                        <GridContainer>
                            <GridItem xs={3}>
                                <Typography variant={variant}>
                                    <I18n trans={'reports:params.date'} />
                                </Typography>
                            </GridItem>
                            <GridItem xs={9}>{DateHelperTs.format(item.proccessingStartedOn)}</GridItem>
                        </GridContainer>
                    )}
                    {Object.keys(params).map((name: any) => {
                        if (params[name] !== null) {
                            return (
                                <GridContainer key={item.id + '_' + name}>
                                    <GridItem xs={6}>
                                        <Typography variant={variant}>
                                            <I18n trans={'reports:params.' + name.toLowerCase()} />
                                        </Typography>
                                    </GridItem>
                                    <GridItem xs={6}>{ReportHelper.getParamValue(item, params[name].toString(), name,translations)}
                                    </GridItem>
                                </GridContainer>
                            );
                        }
                    })}
                </DialogContent>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(ReportView);
